import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceMenuRenderComponent } from './piece-menu-render.component';


export const pieceMenuRenderModuleEntryComponents = [
  PieceMenuRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: pieceMenuRenderModuleEntryComponents
})
export class PieceMenuRenderModule {}

export default pieceMenuRenderModuleEntryComponents;
